module.exports = __webpack_public_path__ + "img/full-logo.fd353df8.png";